/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewer_Faq_Q4Inputs */

const en_viewer_faq_q4 = /** @type {(inputs: Viewer_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does PureJSON validate my JSON?`)
};

const ko_viewer_faq_q4 = /** @type {(inputs: Viewer_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON이 JSON을 검증해 주나요?`)
};

const ja_viewer_faq_q4 = /** @type {(inputs: Viewer_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSONはJSONを検証しますか？`)
};

/**
* | output |
* | --- |
* | "Does PureJSON validate my JSON?" |
*
* @param {Viewer_Faq_Q4Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const viewer_faq_q4 = /** @type {((inputs?: Viewer_Faq_Q4Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewer_Faq_Q4Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewer_faq_q4(inputs)
	if (locale === "ko") return ko_viewer_faq_q4(inputs)
	return ja_viewer_faq_q4(inputs)
});